import { render } from "./a-mastertask-description.vue?vue&type=template&id=2ed63137"
import script from "./a-mastertask-description.vue?vue&type=script&lang=js"
export * from "./a-mastertask-description.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__